// extracted by mini-css-extract-plugin
export default {"btn":"counter-button_btn__nSRPm","counter":"counter-button_counter__Z3jmN","counterBig":"counter-button_counterBig__nCwLy"};